import React, { useState } from "react";

import { flatten } from "lodash/fp";

import type { SxProps } from "@mui/material";
import Collapse from "@mui/material/Collapse";

import { splitAt } from "@app/utils/arrays";

import Stack from "@rui/Stack";

import SeeMoreButton, { SeeMoreButtonProps } from "./SeeMoreButton";

interface ExpandableListProps {
  buttonProps?: Omit<SeeMoreButtonProps, "hide" | "viewingMore">;
  children: React.ReactElement[];
  defaultExpanded?: boolean;
  max: number;
  sx?: SxProps;
}

const ExpandableList = ({
  buttonProps,
  children,
  defaultExpanded = false,
  max,
  sx,
}: ExpandableListProps) => {
  const [expanded, setExpanded] = useState(defaultExpanded);

  const childList = flatten(Array.from(children));
  const expandable = childList.length > max;

  const [defaultChildren, expandedChildren] = splitAt(childList, max);

  const toggleExpanded = () => setExpanded(!expanded);

  return (
    <Stack sx={sx}>
      {defaultChildren}
      {expandable && <Collapse in={expanded}>{expandedChildren}</Collapse>}
      <SeeMoreButton
        {...buttonProps}
        hide={!expandable}
        viewingMore={expanded}
        onClick={toggleExpanded}
      />
    </Stack>
  );
};

export default ExpandableList;
